import styled from "styled-components";
import { Collapse } from "antd";

const { Panel } = Collapse;

export const Container = styled.div``;

export const CustomCollapse = styled(Collapse)`
  border-width: 1px;
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
  border-color: ${({ theme }) => theme.colors.lightGray};
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const CustomCollapsePanel = styled(Panel)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};

  &.ant-collapse-item {
    .ant-collapse-header {
      color: ${({ theme }) => theme.colors.blackGreen};
    }
  }

  &.ant-collapse-item-active {
    .ant-collapse-header {
      color: ${({ theme }) => theme.colors.prune};
    }
  }

  & {
    .ant-collapse-header {
      padding: 0px !important;
      height: 60px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      ${({ theme }) => theme.textStyles.title1};
      font-size: 22px;
      @media only screen and (max-width: 560px) {
        font-size: 20px;
      }
    }
    .ant-collapse-content {
      background-color: ${({ theme }) => theme.colors.lightGray1};
      padding-top: ${({ theme }) => theme.spacings.spacing_xxl};
      padding-left: ${({ theme }) => theme.spacings.spacing_xxl};
      padding-right: 100px;

      .ant-collapse-content-box {
        padding: 0px;
      }

      @media only screen and (max-width: 560px) {
        padding-top: 16px;
        padding-left: 16;
        padding-right: 0;
      }
    }
  }
`;

export const IconWrap = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: ${({ theme }) => theme.spacings.spacing_m};
`;
